import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MatchRuleEntity } from './matchRuleApi';
import { RootState } from './store';

const initialState: Record<number, MatchRuleEntity> = {};

export const matchRuleSlice = createSlice({
  name: 'matchRule',
  initialState,
  reducers: {
    setMatchRule: (state, action: PayloadAction<MatchRuleEntity>) => {
      state[action.payload.id] = action.payload;
    },
    setMatchRules: (state, action: PayloadAction<MatchRuleEntity[]>) => {
      const newState: Record<number, MatchRuleEntity> = {};
      for (const matchRule of action.payload) {
        newState[matchRule.id] = matchRule;
      }
      return newState;
    },
  },
});

export const { setMatchRule, setMatchRules } = matchRuleSlice.actions;

export const selectMatchRule = (id: number) => (state: RootState) => {
  return state.matchRule[id];
};

export const selectMatchRules = (state: RootState) => {
  return state.matchRule;
};

export const selectSortedMatchRules = createSelector(
  [selectMatchRules],
  (matchRules) => {
    return Object.values(matchRules).sort((a, b) => a.sequence - b.sequence);
  }
);

export const selectMatchRuleCount = (state: RootState) => {
  return Object.keys(state.matchRule).length;
};

export default matchRuleSlice.reducer;
